import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
    return (
        <div className="container">
            <div className="not-found-container">
                <h1 className="not-found-title">404</h1>
                <p className="not-found-message">صفحه مورد نظر یافت نشد</p>
                <Link to={-1} className="not-found-link">
                    بازگشت
                </Link>
            </div>
        </div>
    );
};

export default NotFound;
